<ng-container screenAnalytics="airspace-risk">
    <ng-container *ngIf="iframeUrl != null">
        <iframe [src]="iframeUrl" frameborder="0" class="dashboard-iframe">
        </iframe>
    </ng-container>
</ng-container>
<router-outlet></router-outlet>
